import { combineReducers } from "@reduxjs/toolkit";
import { RESET_ACTION_TYPE } from "./index";

import Fleet, { FleetReducerState } from "./Fleet/Fleet.reducer";
import Global, { GlobalReducerState } from "./Global/Global.reducer";
import User, { UserReducerState } from "./User/User.reducer";
import Groups, { GroupsReducerState } from "./Groups/Groups.reducer";
import Insights, { InsightReducerState } from "./Insights/Insights.reducer";
import Program, { ProgramReducerState } from "./Program/Program.reducer";
import Dashboard, { DashboardReducerState } from "./Dashboard/DashboardReducer";

import SupportReducer, {
	SupportReducerState,
} from "../views/Support/Support.reducer";
import DriversReducer, {
	DriverIndexReducerState,
} from "../views/DriverIndex/DriverIndex.reducer";
import DriverProfileReducer, {
	DriverProfileReducerState,
} from "../views/DriverProfile/DriverProfile.reducer";
import InviteDriversFormReducer, {
	InviteDriversFormReducerState,
} from "../components/form/InviteDriversForm/InviteDriversForm.reducer";
import { Action } from "../lib/util/ReduxUtils";

const reducers = {
	DriversReducer,
	DriverProfileReducer,
	SupportReducer,
	InviteDriversFormReducer,

	// new style reducers
	Dashboard,
	Insights,
	Fleet,
	Groups,
	Global,
	User,
	Program,
};

export type StoreState = {
	DriversReducer: DriverIndexReducerState;
	DriverProfileReducer: DriverProfileReducerState;
	SupportReducer: SupportReducerState;
	InviteDriversFormReducer: InviteDriversFormReducerState;

	Dashboard: DashboardReducerState;
	Insights: InsightReducerState;
	Fleet: FleetReducerState;
	Groups: GroupsReducerState;
	Global: GlobalReducerState;
	User: UserReducerState;
	Program: ProgramReducerState;
};

export type GetStoreState = () => StoreState;

// Combine Reducers
const appReducer = combineReducers<StoreState>(reducers as any);

export const rootReducer = (state: StoreState | undefined, action: Action) => {
	return appReducer(
		action.type === RESET_ACTION_TYPE ? undefined : state,
		action,
	);
};
